import {
  CurrentAndPastStakingsQuery,
  CurrentAndPastStakingsQuery$data,
  CurrentAndPastStakingsQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

interface CurrentAndPastStakingsResponse {
  data: CurrentAndPastStakingsQuery$data;
  errors?: string[];
}

export const getCurrentAndPastStakingsData =
  async (): Promise<CurrentAndPastStakingsResponse> => {
    const response = await gqlNetworkFetch<CurrentAndPastStakingsQuery>(
      CurrentAndPastStakingsQueryNode.params,
      {},
    );

    return response;
  };
